import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageTemplate from 'components/PageTemplate'
import LogList from 'components/Treatments/LogList'
import { RootPath } from 'router/enums'

const TreatmentChangeLog = () => {
  const { t } = useTranslation()
  const { treatmentId } = useParams<{ treatmentId: string }>()
  return (
    <PageTemplate
      title={t('Change Log')}
      goBackTo={`${RootPath.SCHEDULE}/${treatmentId}`}
    >
      <LogList />
    </PageTemplate>
  )
}

export default TreatmentChangeLog
